export const WebConfig: IWebConfig[] = [
  {
    // 0
    UrlWeb: ['localhost:4001', 'staging-ag.goodgame66.com'],
    ApiHost: {
      Host: 'https://staging-api.goodgame66.com/',
      HostImage: 'https://staging-api.goodgame66.com/images/',
      OPENAPI: 'https://staging-api.goodgame66.com/',
    },
    Production: false,
    YourBand: {
      en: 'GOODGAME66',
      th: 'GOODGAME66',
    },
    Logo: 'assets/gg-logo/logo-white.png',
    LogoDark: 'assets/gg-logo/logo.png',
    Favicon: 'assets/gg-logo/goodgame66-white-fav.png',
  },
  {
    // 1
    UrlWeb: ['localhost:4000','ag.goodgame66.com', 'ag.goodgame66.org', 'ag.goodgame66.net', 'ag.goodgame66.co'],
    Production: true,
    ApiHost: {
      Host: 'https://gg66api.gg66game-ggwp.space/',
      HostImage: 'https://gg66api.gg66game-ggwp.space/images/',
      OPENAPI: 'https://api.openapixgoodgame.com/',
    },
    YourBand: {
      en: 'GOODGAME66',
      th: 'GOODGAME66',
    },
    Logo: 'assets/gg-logo/logo-white.png',
    LogoDark: 'assets/gg-logo/logo.png',
    Favicon: 'assets/gg-logo/goodgame66-white-fav.png',
  },
  {
    // 2
    UrlWeb: ['ag.naga78king.com', 'backoffice.88play.agency'],
    Production: true,
    ApiHost: {
      Host: 'https://api.naga78king.com/',
      HostImage: 'https://api.naga78king.com/images/',
      OPENAPI: 'https://api.naga78king.com/',
    },
    YourBand: {
      en: '88PLAY',
      th: '88PLAY',
    },
    Logo: 'assets/naga-logo/88play-agency-w.png',
    LogoDark: 'assets/naga-logo/88play-agency.png',
    Favicon: 'assets/naga-logo/88play-agency-fav.png',
  },
];

// onSetupForWeb() {
//   const hostname = location.hostname;
//   if (hostname !== 'localhost') {
//     const find = WebConfig.filter((c) => c.UrlWeb.includes(hostname));
//     this.Config = find.length > 0 ? find[0] : WebConfig[0];
//   } else {
//     this.Config = WebConfig.filter((c) => c.UrlWeb.includes('localhost'))[-1] || WebConfig[2];
//     this.Config.Production = false;
//   }
// }

export const getWebConfig = () => {
  const { hostname, host } = location;

  if (hostname == 'localhost') {
    const findWebConfig = WebConfig.find((c) => c.UrlWeb.includes(host)) || WebConfig[1];
    findWebConfig.languageHost =
      'https://cdn.simplelocalize.io/15d082fccc7f4938a563b40261ec8ffd/_latest/';
    return findWebConfig;
  }

  const webConfig = WebConfig.find((c) => c.UrlWeb.includes(hostname)) || WebConfig[1];
  webConfig.Production = false;
  webConfig.languageHost =
    'https://cdn.simplelocalize.io/15d082fccc7f4938a563b40261ec8ffd/_production/';
  return webConfig;
};

export interface IWebConfig {
  UrlWeb: string[];
  ApiHost: {
    Host: string;
    HostImage: string;
    OPENAPI: string;
  };
  Production: boolean;
  YourBand: {
    th: string;
    en: string;
  };
  Logo: string;
  LogoDark: string;
  Favicon: string;
  createBy?: {
    logo: string;
    name: string;
  };
  languageHost?: string;
}
